import { graphql } from "@/api/graphql/types/gql";

export const SearchTidLinkedAccountTypesQuery = graphql(`
  query SearchTidLinkedAccountTypes(
    $request: BillingMsSearchTidLinkedAccountTypesRequest!
  ) {
    BillingMsSearchTidLinkedAccountTypes(request: $request) {
      data {
        id
        code
      }
    }
  }
`);
